<template>
	<span v-if="value">	
		{{ arrayString }}	
	</span>
</template>
<script>
export default {
    props: ['value'],
    computed: {
    	arrayString: function () 
		{		      
			let array = this.value.map(column => {
			    return column.name
			});
			return array.join(", ");
		}
	}
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/table/value/Array.vue